<template>
  <div class="card">
    <div class="card-content">
      <form ref="form" @submit.prevent="handleUpdateProfile">
        <div class="text-right control-button-wrapper pt-xxs">
          <router-link :to="{ name: 'home' }">
            <button type="button" class="btn btn-cancel btn-primary btn-wd">
              Back
            </button>
          </router-link>
          <acl :permissions="['profile_update']">
            <button
              type="submit"
              class="btn btn-info btn-fill btn-wd submit-button"
              :class="{ loading: $wait.waiting(_uid) }"
            >
              Update
              <i
                v-show="$wait.waiting(_uid)"
                class="fas fa-circle-notch loading-icon"
              />
            </button>
          </acl>
        </div>

        <div class="row">
          <div class="col-md-6">
            <fg-input
              v-model="model.name"
              type="text"
              label="First Name"
              placeholder="First Name"
            />

            <fg-input
              v-model="model.surname"
              type="text"
              label="Last Name"
              placeholder="Last Name"
            />
          </div>

          <div class="col-md-6">
            <fg-input
              v-model="model.username"
              type="email"
              label="Username"
              placeholder="Username"
            />

            <fg-input
              v-model="model.password"
              type="password"
              label="Password"
            />

            <fg-input
              v-model="model.password_confirmation"
              type="password"
              label="Confirm Password"
            />
            <password v-model="model.password" :strength-meter-only="true" :regex="regex"/>
            <p class="password-warning">Your password must contain at least 12 characters, an upper and lower case character, a number and a symbol.</p>
          </div>
        </div>

        <div class="row mb-s pb-s">
          <div class="card-header">
            <h4 class="title">Settings</h4>
          </div>

          <div class="col-md-6 col-xs-12">
            <div class="form-group">
              <label for="notification" class="mr-xs">Notifications</label>
              <p-switch
                v-model="model.settings.notifications"
                type="primary"
                name="notification"
              />
            </div>

            <fg-input
              v-model="model.email"
              type="email"
              label="Email"
              placeholder="Email"
            />
          </div>
        </div>

        <div class="clearfix mb-s" />
      </form>
    </div>
  </div>
</template>
<script>
import _get from "lodash.get";
import { getStorageData } from "@/utils/storage";
import PSwitch from "@components/UIComponents/Switch.vue";
import { mapGetters, mapActions } from "vuex";
import Password from 'vue-password-strength-meter'

export default {
  components: {
    PSwitch,
    Password
  },
  data() {
    const user = getStorageData("user");
    const userSettings = _get(user, "settings", []);

    // TODO: extract this function (find) to a helper
    const notificationSettings = userSettings.find(
      (setting) => setting.type === "notifications"
    );

    const notificationStatus = notificationSettings
      ? notificationSettings.value
      : false;

    const model = {
      name: user.name,
      surname: user.surname,
      email: user.email,
      username: user.username,
      password: null,
      password_confirmation: null,
      settings: {
        notifications: notificationStatus,
      },
    };

    return {
      model,
      regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@.#$%^&*|\\\?\-_~=]).{1,}.{11,}$/,
    };
  },
  computed: {
    ...mapGetters("loadingStore", { isLoading: "loading" }),
  },
  methods: {
    ...mapActions("userStore", ["updateUser"]),
    ...mapActions("loadingStore", ["setLoading"]),
    ...mapActions("errorStore", ["addNewError"]),
    async handleUpdateProfile() {
      try {
        this.$wait.end(this._uid);
        await this.updateUser(this.model);
        this.$notify({
          message: "Data updated successfully!",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "success",
        });
      } catch (error) {
        this.addNewError(error);
      } finally {
        this.model.password = "";
        this.model.password_confirmation = "";
        this.$wait.end(this._uid);
      }
    },
  },
};
</script>
<style>
.Password {
  max-width: none !important;
}

.password-warning {
  font-size: 11px !important;
  margin: 0 !important;
}
</style>
